module.exports = "<pm-formula-item ng-repeat=\"f in $ctrl.formula track by $index\" item=\"f\"></pm-formula-item>\n";